import { render, staticRenderFns } from "./GanttMode.vue?vue&type=template&id=2f1901f1"
import script from "./GanttMode.vue?vue&type=script&lang=js"
export * from "./GanttMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports